import React, { Component, type PropsWithChildren, type ComponentType } from 'react'
import { IssueIcon } from '@instacart/ids-core'
import { errors } from 'utils/error-handling/errors'

interface InsightsPortalErrorBoundaryProps {}

export class InsightsPortalErrorBoundary extends Component<
  InsightsPortalErrorBoundaryProps,
  { hasError: boolean }
> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })

    errors.captureException(error, undefined, {
      extra: {
        componentStack: info.componentStack,
      },
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          css={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 50,
          }}
          data-testid="insights-portal-error-boundary"
        >
          <IssueIcon size={24} color="systemDetrimentalRegular" />
        </div>
      )
    }

    return this.props.children
  }
}

export function withInsightsWidgetErrorBoundary<T>(WrappedComponent: ComponentType<T>) {
  const wrappedWidget = (props: PropsWithChildren<T>) => (
    <InsightsPortalErrorBoundary>
      <WrappedComponent {...props} />
    </InsightsPortalErrorBoundary>
  )

  return wrappedWidget
}
